import axios from './orderInstance'

export interface GetOrdersFilters {
  created_at_from?: string
  created_at_to?: string
}

const getOrders = async (page = 1, size = 100, filters: GetOrdersFilters = {}) => {
  try {
    const response = await axios('/orders', {
      params: {
        page,
        size,
        ...filters,
      },
    })
    return response.data
  } catch {
    return null
  }
}

export default getOrders
